<mat-dialog-content class="main-container">
  <div class="head-container">
    <div class="compania-nombre" [ngSwitch]="controlNgSwitch">
      <h2 style="margin: 0">
        <b>{{ compania.name }}</b>
      </h2>
      <h2>
        Estado: <b *ngSwitchCase="0">Inactiva</b><b *ngSwitchCase="1">Activa</b>
      </h2>
    </div>
      <button class="bg-close-button" mat-fab color="white">
        <mat-icon
          mat-dialog-close="mat-dialog-close"
          style="width: 4vh; height: 4vh; display: flex; align-items: center; justify-content: center;"
          >close</mat-icon>
      </button>
    </div>
  <div class="data-container">
    <div style="width: 50%">
      <h3 style="margin: 0">
        Nit.: {{ compania.nit }}<br />
        Tel.: {{ compania.phone }}<br />
        Cel.: {{ compania.mobile }}<br />
      </h3>
    </div>
    <div
    style="width: 50%; height: 20vh; display: flex; padding: 4vh; background-size: contain; background-repeat: no-repeat; background-position: center;"
    [ngStyle]="{ 'background-image': 'url(' + baseUrl + compania.logo + '/0' +')'}">
      <!-- <img style="width: auto;" height="100px" src="{{ baseUrl + compania.logo }}"/> -->
    </div>
  </div>
  <h3 style="margin: 0">
    Dir.: {{ compania.address }} ({{ compania.city }})<br />
    E-mail: {{ compania.email }}<br />
    Encargado: {{ compania.manager }}
  </h3>
  <br />
  <div class="data-container">
    <div style="width: 50%">
      Usuarios: {{ compania.numberUsers }} <br />
    </div>
    <div style="width: 50%">
      Fecha ultimo pago: {{ compania.lastPaymentDate | dateFormat}} <br />
    </div>
  </div>

    <div class="col-12 m-0 p-0">
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="warn" (click)="eliminarCompania()">Remove</button>
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="primary" (click)="go()">Info</button>
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="primary" (click)="editarCompania(compania)">Edit</button>
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="warn" (click)="logoutAllUsers()">Logout all users</button>
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="warn" (click)="handlerAlert(true)">Active Alert</button>
      <button class="button-company col-5 col-md-4 m-md-2" mat-raised-button color="primary" (click)="handlerAlert(false)">Desactive Alert</button>
    </div>

</mat-dialog-content>
